module.exports = __webpack_public_path__ + "static/media/portfolio--mockup.6a0e2efd.png";